import React, { useEffect } from "react";
import { Controller } from "react-hook-form";

export default function Documentation({
  register,
  errors,
  watch,
  setValue,
  control,
  updateData,
  clearErrors,
}) {
  // Define the checkbox options in an array for easy mapping.
  const documentOptions = [
    {
      id: "valid_Canadian_Passport",
      name: "valid_canadian_passport",
      label: "Valid Passport",
      defaultChecked: true, // Set this checkbox as checked by default
    },
    {
      id: "canadianCitizenshipOrPRCard",
      name: "canadian_citizenship_or_prCard",
      label: "Canadian Citizenship/PR Card",
    },
    {
      id: "validTravelVisa",
      name: "valid_travel_visa",
      label: "Valid Travel Visa",
    },
    {
      id: "touristCard",
      name: "tourist_card",
      label: "Tourist Card",
    },
  ];

  const defaultSpecialRemarks = `**IMPORTANT NOTE:**  
Passengers must ensure that the name on their ticket matches their passport's name. For those traveling through the USA, a valid visa is required. Passengers flying via Europe must present a valid and stamped Canadian visa. We advise you to confirm all visa requirements with your airline or the appropriate consulate/embassy, as we cannot guarantee that any restrictions due to visa issues will be lifted. Please verify that your travel dates and times match your booking, and note that we are not responsible for any schedule changes made by the airline—although we are happy to help, all available options must first be confirmed with the carrier. In addition, passengers are required to report to the airport 4–5 hours before departure. For Indian passport holders, kindly check the validity of your passport, PR Card, and Work Permit (TRV). Canadian citizens must ensure that their passport is valid for more than six months at the time of travel and that they possess either an Indian visa or an OCI card as mandated. To confirm all these requests, please call us at least 72 hours before your travel.  
Thank you.  
Email: travelsystem@gmail.com | Website: www.maharajaflights.com`;

  return (
    <section className="bg-[#e5f4df] p-4">
      <h2 className="text-md bg-[#c7ddbe] px-2 py-1 font-semibold text-black">
        Documentation and Remarks
      </h2>
      <div className="px-2 py-2 text-sm text-black">
        <p className="mb-2">Travel Documents Required:</p>
        <div className="flex flex-col space-y-1">
          {documentOptions.map((doc) => (
            <div key={doc.id} className="flex items-center">
              <Controller
                control={control}
                name={doc.name}
                defaultValue={doc.defaultChecked || false}
                render={({ field: { onChange, value, ref } }) => (
                  <input
                    type="checkbox"
                    id={doc.id}
                    checked={value}
                    onChange={(e) => onChange(e.target.checked)}
                    ref={ref}
                  />
                )}
              />
              <label
                htmlFor={doc.id}
                className="ml-2 cursor-pointer font-light"
              >
                {doc.label}
              </label>
            </div>
          ))}
          <div>
            <label
              htmlFor="special-remarks"
              className="cursor-pointer font-light"
            >
              Special Remarks
            </label>
            <textarea
              id="special-remarks"
              className="w-full rounded border border-gray-600 bg-white p-2 text-black focus:border-blue-500 focus:outline-none"
              rows={10}
              defaultValue={defaultSpecialRemarks}
              {...register("special_remarks")}
            />
          </div>
          <div>
            <label
              htmlFor="other-remarks"
              className="cursor-pointer font-light"
            >
              Insurance/Other Remarks
            </label>
            <textarea
              id="other-remarks"
              className="w-full rounded border border-gray-600 bg-white p-2 text-black focus:border-blue-500 focus:outline-none"
              rows={5}
              defaultValue={"Insurance offered, but declined."}
              {...register("other_remarks")}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
